// extracted by mini-css-extract-plugin
export default {"annotationsHeaderFileName":"AlertsSidePanel-module__annotationsHeaderFileName--MuEfW"};